import { createFileRoute } from '@tanstack/react-router'

import { UpdateDetail } from '@/modules/updates'
import {
  fetchUpdate,
  fetchUpdateNav,
} from '@/modules/updates/service/changelog'
import { captureException } from '@/services/monitoring/captureException'

export const Route = createFileRoute('/_authenticated/updates/$slug')({
  staticData: { dynamicTitle: true },
  loader: async ({ params }) => {
    try {
      const [update, nav] = await Promise.all([
        fetchUpdate(params.slug),
        fetchUpdateNav(params.slug),
      ])
      return { update, ...nav }
    } catch (error) {
      captureException(error as Error)
      return { update: null, previous: null, next: null }
    }
  },
  component: WhatsNewEntryPage,
})

function WhatsNewEntryPage() {
  const { update, previous, next } = Route.useLoaderData()
  return <UpdateDetail update={update} previous={previous} next={next} />
}
